import { render, staticRenderFns } from "./SubDepartmentForm.vue?vue&type=template&id=f1be4dda&"
import script from "./SubDepartmentForm.vue?vue&type=script&lang=js&"
export * from "./SubDepartmentForm.vue?vue&type=script&lang=js&"
import style0 from "./SubDepartmentForm.vue?vue&type=style&index=0&id=f1be4dda&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports